import React from 'react';
import { Timer as HeaderTimer } from '@pegasus/ui-headers/components/Timer';
import { useTimer } from '@pegasus/cart/hooks';
import { Cart } from '@pegasus/cart/types/cart';

export interface Props {
    cart?: Cart;

    onCartExpiresFirstWarning: () => void;
    onCartExpiresSecondWarning: () => void;
    onCartExpiresLastWarning: () => void;
    onCartExpired: () => void;
}

export const Timer = ({ cart, ...options }: Props) => {
    const { counter } = useTimer(cart, options);

    return <HeaderTimer timeLeft={counter} />;
};
